/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-21, 09:51:17
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 11:57:54
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import Vue from 'vue';
import store from '@/store';
import sErrorHandler from '@/services/sErrorHandler';

/**
 * Dekorator dla akcji w Vuex, który pozwala na informowanie o akcja, które aktualnie
 * trwają
 */
export const togglePendingStoreActions = () =>
  (target, key, descriptor) => {
    const _descriptor = descriptor;
    const orginalMethod = _descriptor.value;
    _descriptor.value = async function (...args) {
      const storeActionsName = key;
      store.commit('TOGGLE_PENDING_STORE_ACTIONS', storeActionsName);
      await orginalMethod.apply(this, args);
      store.commit('TOGGLE_PENDING_STORE_ACTIONS', storeActionsName);
      return Promise.resolve();
    };
    return descriptor;
  };

export const handleErrorResponses = () =>
  (target, key, descriptor) => {
    const _descriptor = descriptor;
    const orginalMethod = descriptor.value;
    _descriptor.value = async function (...args) {
      try {
        await orginalMethod.apply(this, args);
      } catch (err) {
        const status = err.response.status;
        const errors = err.response.data.data;
        if (status === 406) {
          const errorMessage = sErrorHandler.createErrorMessage(errors);
          (new Vue()).$toaster.error(errorMessage);
        }
      }
    };
    return descriptor;
  };



// WEBPACK FOOTER //
// ./src/utils/decorators.js